import { Component, OnInit } from '@angular/core';
import { AdminService } from 'app/admin/admin.service';
import { User } from "app/shared/shared.module";
@Component({
  selector: 'app-admin-area',
  templateUrl: './admin-area.component.html',
  styleUrls: ['./admin-area.component.css']
})
export class AdminAreaComponent implements OnInit {

    constructor(private adminService: AdminService) { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/admin/admin-area.component.ts